export type ICashbackDetailsResources = typeof CashbackDetailsResources;

export const CashbackDetailsResources = {
    specialCashbackBadgeTitle: "SUPEROFERTA",
    specialCashbackTimeLimitText: "Oferta ważna do",
    cbAriaLabel: "Zwrot cashback {0}",
    cbSpecialAriaLabel: "Zwrot cashback {0}, poprzednio {1}",
    shoppingMallAriaLabel: "Sprawdź wszystkie oferty dla centrum handlowego {0}",
    flyerAriaLabel: "Zobacz wszystkie {0} promocje i ulotki",
    logoAlt: "Sklep",
};
